import { devWarn } from "./devWarn";

const SSR_WARNING =
    "[HallidayPayments] No DOM available (server-side render?) — widget effect skipped. " +
    "preload()/open*() are no-ops without a document; invoke them in the browser.";

/**
 * Run an effecting widget action through the DOM-ready gate. Effecting methods never throw on
 * *timing*; they return void and defer here.
 *
 * - **No DOM (server render):** a **no-op with a dev warning** — there is no `DOMContentLoaded` to flush
 *   on, so the effect is not deferred-then-run; it simply does nothing server-side.
 * - **Document still loading:** queue the effect; it flushes on `DOMContentLoaded` (in registration order).
 * - **Document ready:** defer to a microtask so the effect never runs *synchronously* inside the caller.
 *   This keeps the constructor's scheduled auto-warm out of the construction call — so a synchronous
 *   `new HallidayPayments(...).on(...)` cannot miss an event — while staying effectively instant.
 *
 * @internal
 */
export const onDomReady = (effect: () => void): void => {
    if (typeof document === "undefined" || typeof window === "undefined") {
        devWarn(SSR_WARNING);
        return;
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", effect, { once: true });
    } else {
        queueMicrotask(effect);
    }
};
